import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    CreateNivalizTransaction,
    ExtendedNivalizTransaction,
    ExtendedNivalizTransactionListResponse,
    ExtendedNivalizTransactionQueryParams,
    UpdateNivalizTransaction
} from '@frontend/transaction/types';

/**
 * Nivaliz transaction API.
 * List/create/get use `/ext/v1`; patch/delete use `/v1`.
 */
export class TransactionNivalizExtendedClient extends APIClient {
    public static readonly endpoint = '/transaction-api';

    public static async fetchExtendedNivalizTransactions(
        queryParams?: ApiQueryParams<ExtendedNivalizTransactionQueryParams>
    ): Promise<ExtendedNivalizTransactionListResponse> {
        return this.apiPaginated<ExtendedNivalizTransactionListResponse, ExtendedNivalizTransactionQueryParams>(
            `${this.endpoint}/ext/v1/nivaliz-transactions`,
            queryParams
        );
    }

    /** Personal (“my”) nivaliz transactions — supports `deceased` search; not the generic my-transactions list. */
    public static async fetchMyNivalizTransactions(
        queryParams?: ApiQueryParams<ExtendedNivalizTransactionQueryParams>
    ): Promise<ExtendedNivalizTransactionListResponse> {
        return this.apiPaginated<ExtendedNivalizTransactionListResponse, ExtendedNivalizTransactionQueryParams>(
            `${this.endpoint}/ext/v1/my-nivaliz-transactions`,
            queryParams
        );
    }

    public static async fetchExtendedNivalizTransaction(accountId: string, transactionId: string): Promise<ExtendedNivalizTransaction> {
        const response = await this.fetch(`${this.endpoint}/ext/v1/accounts/${accountId}/nivaliz-transactions/${transactionId}`);
        return await this.handleResponse<ExtendedNivalizTransaction>(response);
    }

    public static async postExtendedNivalizTransaction(accountId: string, body: CreateNivalizTransaction): Promise<ExtendedNivalizTransaction> {
        const response = await this.post(`${this.endpoint}/ext/v1/accounts/${accountId}/nivaliz-transactions`, body);
        return await this.handleResponse<ExtendedNivalizTransaction>(response);
    }

    public static async patchNivalizTransaction(accountId: string, transactionId: string, body: UpdateNivalizTransaction): Promise<ExtendedNivalizTransaction> {
        const response = await this.patch(`${this.endpoint}/v1/accounts/${accountId}/nivaliz-transactions/${transactionId}`, body);
        return await this.handleResponse<ExtendedNivalizTransaction>(response);
    }

    public static async deleteNivalizTransaction(accountId: string, transactionId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/v1/accounts/${accountId}/nivaliz-transactions/${transactionId}`);
        return await this.handleVoidResponse(response);
    }
}
